import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Layout from "../../HorizontalMenu/Menu";
import Navbar from "../../HorizontalMenu/Navbar";
import '../../global/GlobalCSS.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../';
import { VesselState, setReportID, setVesselState, setSelectedOperations } from "../../Store/Generic/ReportingSlice";
import { fetchSavedOperation, Get } from "../../VesselMaster/vesselMaster.hooks";
import { queryKeyes } from "shared/queryKeys";
import { useQuery } from "react-query";
import { AddInfoConstant, EngineerReportTabsConstant, SpecialOpsConstant, VesselTypeConstant } from "shared/constants";
import env from "environment_system/env_system";
import ErrorComponent from "Components/ErrorComponent";
import { useDocumentTitle } from "Components/useDocument.hooks";
import { checkValidArray, checkValidObject, compareNumbers, isReeferContainerApplicable, isRunningHoursApplicable, isVoyageParametersApplicable, sortUniqueNumbers, useSafeFormikContext } from "GenericForms/Helper";
import EngineerReportingStructure from "./EngineerReportingStructure";
import FormLoading from "Components/FormLoading";
import { useEditReport } from "VesselReportingInfo/EditCompletedReports/EditReportProvider";

const EngineerWizard = () => {
    /** State varibles */
    const { tabsIdList, setTabsIdList, setActiveAddLfondsTab, activeAddEconTab, setActiveAddEconTab, activeAddLfondsTab, setPreviousTabIndex, previousEnggTabIndex, editReportBool, setEnggActiveTabId, setSaveOrSubmit, setDiscardwarning, activeAddAryaTab } = useEditReport();
    const dispatch = useDispatch();
    const { ReportID, CurrentVessel, CurrentReport, reportingLoading, ConfigurationLimits, reportingError, SelectedOperations } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    const [errorMessage, setErrorMessage] = useState<any>();
    const [refreshFuelROB, setRefreshFuelROB] = useState(0);
    const formikContext = useSafeFormikContext<any>();
    const editValues = formikContext?.values;
    const editInitialValues = formikContext?.initialValues;
    const reefer_container_available = ConfigurationLimits?.reefer_container_available ?? false;
    const specialOpSettingObject = ConfigurationLimits?.special_operation_setting ?? {};
    useDocumentTitle((activeAddEconTab === EngineerReportTabsConstant.AdditionalDetailsId && "Additional Details - ecoSAIL"))
    const runningHrsMachineries = ConfigurationLimits?.vessel_machinery_list?.filter((item: any) => item.running_hour === true);
    const isOptionalOperationPerformed = (item: any): boolean => {
        switch (item.constant) {
            case "fuel_bunkering":
                return (checkValidArray(editInitialValues?.chief_engineer?.bunkering) ||
                    checkValidArray(editValues?.chief_engineer?.bunkering));
            case "fuel_debunkering":
                return checkValidArray(editInitialValues?.chief_engineer?.fuel_debunkering);
            case "lube_oil_bunkering":
                return checkValidArray(editInitialValues?.chief_engineer?.lube_oil_bunkering);
            case "lube_oil_debunkering":
                return checkValidArray(editInitialValues?.chief_engineer?.lube_oil_debunkering);
            case "cargo_heating":
                return (
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_fuel
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_HEATING)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_sub_type_fc
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_HEATING)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_energy
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_HEATING)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_4_hours_reporting
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_HEATING))
                );
            case "cargo_discharging":
                return (
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_fuel
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_DISCHARGING)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_sub_type_fc
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_DISCHARGING)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_energy
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_DISCHARGING)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_4_hours_reporting
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_DISCHARGING))
                );
            case "cargo_cooling":
                return (
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_fuel
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_COOLING)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_sub_type_fc
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_COOLING)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_energy
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_COOLING)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_4_hours_reporting
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_COOLING))
                );
            case "cargo_reliquification":
                return (
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_fuel
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_RELIQUIFICATION)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_sub_type_fc
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_RELIQUIFICATION)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_energy
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_RELIQUIFICATION)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_4_hours_reporting
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.CARGO_RELIQUIFICATION))
                );
            case "reefer_container":
                return (
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_fuel
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.REEFER_CONTAINER)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_sub_type_fc
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.REEFER_CONTAINER)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_energy
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.REEFER_CONTAINER)) ||
                    checkValidArray(editInitialValues?.chief_engineer?.special_operation_4_hours_reporting
                        ?.filter((item: any) => item.special_operation === SpecialOpsConstant.REEFER_CONTAINER))
                );
            default:
                return false;
        }
    }
    /** State varibles end */

    /** useQueries */
    const { data: reeferContainerDetails, isLoading: reeferContainerDetailsLoading }:
        { data: any, isLoading: any, isError: any } = useQuery(
            [queryKeyes.vessel.PreviousDFBReeferContainer.key, ReportID],
            async () => { return await Get(queryKeyes.vessel.PreviousDFBReeferContainer.url(ReportID), ReportID) },
            {
                enabled: true,
                staleTime: 0,
            }
        );
    const { data: SavedOperation } = useQuery(
        [queryKeyes.vessel.OptionalOperationStatus.key, ReportID],
        () => fetchSavedOperation(ReportID),
        {
            enabled: !!ReportID,
            staleTime: Infinity,
            onSuccess: (data) => {
                let tempSelectedOps = [...SelectedOperations];
                Object.keys(data)?.forEach((item: any) => {
                    handleTabsList(data[item], dynamicTabs?.filter((tab: any) => tab.constant === item)[0]);
                    if (data[item] === true) {
                        tempSelectedOps.push(dynamicTabs?.find((tab: any) => tab.constant === item)?.id);
                        if (!editReportBool && dynamicTabs?.find((tab: any) => tab.constant === item)?.id === EngineerReportTabsConstant.BunkeringId) {
                            tempSelectedOps.push(EngineerReportTabsConstant.BDNId);
                        }
                    } else {
                        if (tempSelectedOps.includes(dynamicTabs?.find((tab: any) => tab.constant === item)?.id)) {
                            tempSelectedOps.splice(tempSelectedOps.indexOf(dynamicTabs?.find((tab: any) => tab.constant === item)?.id), 1);
                            if (!editReportBool && dynamicTabs?.find((tab: any) => tab.constant === item)?.id === EngineerReportTabsConstant.BunkeringId) {
                                tempSelectedOps.splice(tempSelectedOps.indexOf(EngineerReportTabsConstant.BDNId), 1);
                            }
                        }
                    }
                    dispatch(setSelectedOperations(tempSelectedOps));
                })
            }
        }
    );
    /** End Queries */

    /** List of dynamic tabs & their properties */
    const dynamicTabs: any[] = [
        {
            id: EngineerReportTabsConstant.BunkeringId,
            tab: 'Bunkering',
            constant: 'fuel_bunkering',
            group: 3,
            vessel_type_precedence_id: [VesselTypeConstant.OTHER]
        },
        {
            id: EngineerReportTabsConstant.BDNId,
            tab: 'BDN',
            vessel_type_precedence_id: [VesselTypeConstant.OTHER]
        },
        {
            id: EngineerReportTabsConstant.FuelDebunkeringId,
            tab: 'Fuel Debunkering',
            group: 3,
            constant: "fuel_debunkering",
            vessel_type_precedence_id: [VesselTypeConstant.OTHER]
        },
        {
            id: EngineerReportTabsConstant.LubeOilBunkeringId,
            tab: 'Lube Oil Bunkering',
            group: 3,
            constant: 'lube_oil_bunkering',
            vessel_type_precedence_id: [VesselTypeConstant.OTHER]
        },
        {
            id: EngineerReportTabsConstant.LubeOilDebunkeringId,
            tab: 'Lube Oil Debunkering',
            constant: 'lube_oil_debunkering',
            group: 3,
            vessel_type_precedence_id: [VesselTypeConstant.OTHER]
        },
        {
            id: EngineerReportTabsConstant.CargoHeatingId,
            tab: 'Special Operations - Cargo Heating',
            group: 1,
            vessel_type_precedence_id: [VesselTypeConstant.TANKER],
            applicable: specialOpSettingObject && specialOpSettingObject?.cargo_heating,
            sp_op_constant: SpecialOpsConstant.CARGO_HEATING,
            constant: 'cargo_heating'
        },
        {
            id: EngineerReportTabsConstant.TankCleaningId,
            tab: 'Special Operations - Tank Cleaning',
            group: 2,
            vessel_type_precedence_id: [VesselTypeConstant.TANKER],
            applicable: specialOpSettingObject && specialOpSettingObject?.tank_cleaning,
            sp_op_constant: SpecialOpsConstant.TANK_CLEANING,
            constant: 'tank_cleaning'
        },
        {
            id: EngineerReportTabsConstant.CargoDischargingId,
            tab: 'Special Operations - Cargo Discharging',
            group: 1,
            vessel_type_precedence_id: [VesselTypeConstant.TANKER],
            applicable: specialOpSettingObject && specialOpSettingObject?.cargo_discharging,
            sp_op_constant: SpecialOpsConstant.CARGO_DISCHARGING,
            constant: 'cargo_discharging'
        },
        {
            id: EngineerReportTabsConstant.ReeferContainerId,
            tab: 'Special Operations - Reefer Container',
            group: 1,
            vessel_type_precedence_id: [VesselTypeConstant.CONTAINER, VesselTypeConstant.GENERAL_CARGO_SHIP],
            applicable: specialOpSettingObject && specialOpSettingObject?.reefer_container && reefer_container_available,
            sp_op_constant: SpecialOpsConstant.REEFER_CONTAINER,
            constant: 'reefer_container'
        },
        {
            id: EngineerReportTabsConstant.CargoCoolingId,
            tab: 'Special Operations - Cargo Cooling',
            group: 1,
            vessel_type_precedence_id: [VesselTypeConstant.GAS_CARRIER, VesselTypeConstant.LNG_CARRIER],
            applicable: specialOpSettingObject && specialOpSettingObject?.cargo_cooling,
            sp_op_constant: SpecialOpsConstant.CARGO_COOLING,
            constant: 'cargo_cooling'
        },
        {
            id: EngineerReportTabsConstant.CargoReliquificationId,
            tab: 'Special Operations - Cargo Reliquification',
            group: 1,
            vessel_type_precedence_id: [VesselTypeConstant.GAS_CARRIER, VesselTypeConstant.LNG_CARRIER],
            applicable: specialOpSettingObject && specialOpSettingObject?.cargo_reliquification,
            sp_op_constant: SpecialOpsConstant.CARGO_RELIQUIFICATION,
            constant: 'cargo_reliquification'
        },
        {
            id: EngineerReportTabsConstant.OtherSpecialOperationId,
            tab: 'Other Special Operation',
            group: 2,
            vessel_type_precedence_id: [VesselTypeConstant.OTHER]
        },
    ];
    /** Function to check if a special operation is applicable for edit reporting */
    const editApplicableSpOpTab = (tab: any) => {
        if (editValues?.chief_engineer?.special_operation_fuel?.length > 0) {
            return editValues?.chief_engineer?.special_operation_fuel?.some((fuel: any) => {
                return fuel.special_operation === tab.sp_op_constant
            })
        }
        if (editValues?.chief_engineer?.special_operation_energy?.length > 0) {
            return editValues?.chief_engineer?.special_operation_energy?.some((fuel: any) =>
                fuel.special_operation === tab.sp_op_constant
            )
        }
        if (editValues?.chief_engineer?.special_operation_4_hours_reporting?.length > 0) {
            return editValues?.chief_engineer?.special_operation_energy?.some((fuel: any) =>
                fuel.special_operation === tab.sp_op_constant
            )
        }
        if (editValues?.chief_engineer?.special_operation_sub_type_fc?.length > 0) {
            return editValues?.chief_engineer?.special_operation_sub_type_fc?.some((fuel: any) =>
                fuel.special_operation === tab.sp_op_constant
            )
        }
    }
    /** Function check which special operation is applicable for edit reporting */
    let editApplicableSpOpTabIds: number[] = [];
    dynamicTabs?.filter((item: any) => item?.group === 1 && item?.applicable && editApplicableSpOpTab(item))?.forEach((tab: any) => {
        editApplicableSpOpTabIds.push(tab?.id);
    })
    /** useEfect */
    useEffect(() => {
        let data: any[] = [];
        data = [
            EngineerReportTabsConstant.OptionalOperationsId,
            ...(isVoyageParametersApplicable(currentVesselReport) ? [EngineerReportTabsConstant.VoyageParameterId] : []),
            ...(isRunningHoursApplicable(currentVesselReport, runningHrsMachineries) ? [EngineerReportTabsConstant.MachineryRunningHrsId] : []),
            EngineerReportTabsConstant.FuelConsumptionId,
            EngineerReportTabsConstant.LubeOilConsumptionId,
            EngineerReportTabsConstant.FreshWaterId,
            ...(checkValidArray(SelectedOperations) ? [...sortUniqueNumbers(SelectedOperations).map((item: any) => { return item })] : []),
            ...(env?.additional_info_engg !== AddInfoConstant.NONE ? [EngineerReportTabsConstant.AdditionalDetailsId] : []),
            EngineerReportTabsConstant.RemarksId,
        ]
        data.sort(compareNumbers);
        setTabsIdList(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentVesselReport, SelectedOperations])
    useEffect(() => {
        if (!editReportBool) {
            setEnggActiveTabId(EngineerReportTabsConstant.OptionalOperationsId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editReportBool])
    useEffect(() => {
        let tempSelectedOps = [...SelectedOperations];
        checkValidObject(SavedOperation) && Object.keys(SavedOperation)?.forEach((item: any) => {
            handleTabsList(SavedOperation[item], dynamicTabs?.filter((tab: any) => tab.constant === item)[0]);
            if (SavedOperation[item] === true) {
                tempSelectedOps.push(dynamicTabs?.find((tab: any) => tab.constant === item)?.id);
                if (!editReportBool && dynamicTabs?.find((tab: any) => tab.constant === item)?.id === EngineerReportTabsConstant.BunkeringId) {
                    tempSelectedOps.push(EngineerReportTabsConstant.BDNId);
                }
            } else {
                if (tempSelectedOps.includes(dynamicTabs?.find((tab: any) => tab.constant === item)?.id)) {
                    tempSelectedOps.splice(tempSelectedOps.indexOf(dynamicTabs?.find((tab: any) => tab.constant === item)?.id), 1);
                }
            }
            if (isReeferContainerApplicable(
                CurrentVessel,
                currentVesselReport,
                reeferContainerDetails,
                specialOpSettingObject,
                reefer_container_available,
                editReportBool,
                tabsIdList
            )) {
                tempSelectedOps.push(EngineerReportTabsConstant.ReeferContainerId);
            }
            dispatch(setSelectedOperations(tempSelectedOps));
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SavedOperation])
    useEffect(() => {
        if (isReeferContainerApplicable(
            CurrentVessel,
            currentVesselReport,
            reeferContainerDetails,
            specialOpSettingObject,
            reefer_container_available,
            editReportBool,
            tabsIdList
        )) {
            handleTabsList(true, dynamicTabs?.find((tab: any) => tab.id === EngineerReportTabsConstant.ReeferContainerId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CurrentVessel, reeferContainerDetails, currentVesselReport, specialOpSettingObject, reefer_container_available])
    useEffect(() => {
        if (editReportBool && checkValidArray(editValues?.chief_engineer?.bunkering)) {
            handleTabsList(true, dynamicTabs?.find((tab: any) => tab.id === EngineerReportTabsConstant.BunkeringId));
        }
        if (editReportBool && checkValidArray(editValues?.chief_engineer?.fuel_debunkering)) {
            handleTabsList(true, dynamicTabs?.find((tab: any) => tab.id === EngineerReportTabsConstant.FuelDebunkeringId));
        }
        if (editReportBool && checkValidArray(editValues?.chief_engineer?.lube_oil_bunkering)) {
            handleTabsList(true, dynamicTabs?.find((tab: any) => tab.id === EngineerReportTabsConstant.LubeOilBunkeringId));
        }
        if (editReportBool && checkValidArray(editValues?.chief_engineer?.lube_oil_debunkering)) {
            handleTabsList(true, dynamicTabs?.find((tab: any) => tab.id === EngineerReportTabsConstant.LubeOilDebunkeringId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editInitialValues, editValues])
    /** useEffect end */

    /** Function to change optional tabs */
    const toggleDynamicTabs = (tab: any) => {
        setPreviousTabIndex(tab);
        setEnggActiveTabId(tabsIdList[tab]);
    }
    /** Function to update vessel state globally */
    const handleVesselState = (currentVesselReport: VesselState) => {
        dispatch(setVesselState(currentVesselReport))
        dispatch(setReportID(null))
        dispatch(setSelectedOperations([]))
    }
    /** Function to filter tabs list which are displayed */
    const handleTabsList = (checked: any, item: any, userClicked: boolean = false): any => {
        let data = [...tabsIdList];
        let tempSelectedOps = [...SelectedOperations];
        if (checked === true) {
            if (!tempSelectedOps.includes(item?.id)) {
                tempSelectedOps.push(item?.id);
            }
            if (item?.id === EngineerReportTabsConstant?.BunkeringId && !editReportBool &&
                !tempSelectedOps.includes(EngineerReportTabsConstant?.BDNId)) {
                tempSelectedOps.push(EngineerReportTabsConstant?.BDNId);
            }
            dispatch(setSelectedOperations(tempSelectedOps));
            data.push(item?.id);
            if (!editReportBool && item?.id === EngineerReportTabsConstant?.BunkeringId) {
                data.push(EngineerReportTabsConstant?.BDNId);
            }
            data.sort(compareNumbers);
        } else {
            if (item?.id !== EngineerReportTabsConstant?.ReeferContainerId) {
                tempSelectedOps.splice(tempSelectedOps.indexOf(item?.id), 1);
                if (item?.id === EngineerReportTabsConstant?.BunkeringId && !editReportBool) {
                    tempSelectedOps.splice(tempSelectedOps.indexOf(EngineerReportTabsConstant?.BDNId), 1);
                }
            }
            dispatch(setSelectedOperations(tempSelectedOps));
            let idx = data.indexOf(item?.id);
            data.splice(idx, 1);
            if (item?.id === EngineerReportTabsConstant?.BunkeringId && !editReportBool) {
                data.splice(data.indexOf(EngineerReportTabsConstant?.BDNId), 1);
            }
            data.sort(compareNumbers);
        }
        if (!userClicked) {
            if (isReeferContainerApplicable(
                CurrentVessel,
                currentVesselReport,
                reeferContainerDetails,
                specialOpSettingObject,
                reefer_container_available,
                editReportBool,
                tabsIdList
            )) {
                tempSelectedOps.push(EngineerReportTabsConstant?.ReeferContainerId);
            }
        } else if (item?.id === EngineerReportTabsConstant?.ReeferContainerId && userClicked && !checked) {
            tempSelectedOps.splice(tempSelectedOps.indexOf(EngineerReportTabsConstant?.ReeferContainerId), 1);
        }
        dispatch(setSelectedOperations(tempSelectedOps));
        [
            EngineerReportTabsConstant.OptionalOperationsId,
            ...(isVoyageParametersApplicable(currentVesselReport) ? [EngineerReportTabsConstant.VoyageParameterId] : []),
            ...(isRunningHoursApplicable(currentVesselReport, runningHrsMachineries) ? [EngineerReportTabsConstant.MachineryRunningHrsId] : []),
            EngineerReportTabsConstant.FuelConsumptionId,
            EngineerReportTabsConstant.LubeOilConsumptionId,
            EngineerReportTabsConstant.FreshWaterId,
            ...(checkValidArray(tempSelectedOps) ? [...sortUniqueNumbers(tempSelectedOps).map((item: any) => { return item })] : []),
            ...(env?.additional_info_engg !== AddInfoConstant.NONE ? [EngineerReportTabsConstant.AdditionalDetailsId] : []),
            EngineerReportTabsConstant.RemarksId,
        ]?.forEach((tab: number) => {
            data.push(tab);
        })
        data.sort(compareNumbers);
        data = sortUniqueNumbers(data);
        setTabsIdList(data);
    };

    /** Change Lfonds' additional information's tabs */
    const toggleAddLfondsTab = (tab: number) => {
        if (tab >= 1 && tab <= ((currentVesselReport?.is_noon_report ||
            currentVesselReport?.only_noon_or_combine_with_other_event === "combine_with_other_report") ? 3 : 2)) {
            setActiveAddLfondsTab(tab);
        }
    }

    /** Change Econ's additional information's tabs */
    const toggleAddEconTab = (tab: number) => {
        if (tab >= 1 && tab <= ((currentVesselReport?.is_noon_report ||
            currentVesselReport?.only_noon_or_combine_with_other_event === "combine_with_other_report") ? 3 : 1)) {
            setActiveAddEconTab(tab);
        }
    }
    return (
        <React.Fragment>
            {
                !editReportBool ?
                    <React.Fragment>
                        <Layout>
                            <Navbar />
                        </Layout>
                        <div className="page-content">
                            <Container fluid>
                                {(reeferContainerDetailsLoading || reportingLoading) && <FormLoading />}
                                {(reportingError) && <ErrorComponent message="Error loading required data!" />}
                                {!(reeferContainerDetailsLoading || reportingLoading) &&
                                    !(reportingError) &&
                                    <EngineerReportingStructure
                                        handleVesselState={handleVesselState}
                                        errorMessage={errorMessage}
                                        setErrorMessage={setErrorMessage}
                                        toggleDynamicTabs={toggleDynamicTabs}
                                        previousTabIndex={previousEnggTabIndex}
                                        tabsList={dynamicTabs}
                                        refreshFuelROB={refreshFuelROB}
                                        setRefreshFuelROB={setRefreshFuelROB}
                                        reeferContainerDetails={reeferContainerDetails}
                                        handleTabsList={handleTabsList}
                                        SavedOperation={SavedOperation}
                                        toggleAddLfondsTab={toggleAddLfondsTab}
                                        toggleAddEconTab={toggleAddEconTab}
                                        setSaveOrSubmit={setSaveOrSubmit}
                                        setDiscardwarning={setDiscardwarning}
                                        specialOpSettingObject={specialOpSettingObject}
                                        isOptionalOperationPerformed={isOptionalOperationPerformed}
                                        activeAddAryaTab={activeAddAryaTab}
                                    />
                                }
                            </Container>
                        </div>
                    </React.Fragment> :
                    <React.Fragment>
                        {(reeferContainerDetailsLoading || reportingLoading) && <FormLoading />}
                        {(reportingError) && <ErrorComponent message="Error loading required data!" />}
                        {!(reeferContainerDetailsLoading || reportingLoading) &&
                            !(reportingError) &&
                            <EngineerReportingStructure
                                handleVesselState={handleVesselState}
                                errorMessage={errorMessage}
                                setErrorMessage={setErrorMessage}
                                toggleDynamicTabs={toggleDynamicTabs}
                                tabsList={dynamicTabs}
                                refreshFuelROB={refreshFuelROB}
                                setRefreshFuelROB={setRefreshFuelROB}
                                reeferContainerDetails={reeferContainerDetails}
                                handleTabsList={handleTabsList}
                                SavedOperation={SavedOperation}
                                toggleAddLfondsTab={toggleAddLfondsTab}
                                toggleAddEconTab={toggleAddEconTab}
                                activeAddLfondsTab={activeAddLfondsTab}
                                setSaveOrSubmit={setSaveOrSubmit}
                                setDiscardwarning={setDiscardwarning}
                                isOptionalOperationPerformed={isOptionalOperationPerformed}
                                activeAddAryaTab={activeAddAryaTab}
                            />
                        }
                    </React.Fragment>
            }
        </React.Fragment>
    );
};

export default EngineerWizard

